import { render, staticRenderFns } from "./Asignacion_prog_v4.vue?vue&type=template&id=71b44b60&scoped=true"
import script from "./Asignacion_prog_v4.vue?vue&type=script&lang=js"
export * from "./Asignacion_prog_v4.vue?vue&type=script&lang=js"
import style0 from "./Asignacion_prog_v4.vue?vue&type=style&index=0&id=71b44b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b44b60",
  null
  
)

export default component.exports